import { jsx as _jsx } from "react/jsx-runtime";
import { CurrentPatientProvider, PredictionPage, Spinner, } from "@madmedical/ui";
import { useParams } from "@madmedical/routing";
import { invariant } from "@madmedical/utils";
import { usePatient } from "@madmedical/user";
import { useGetPredictionQuery } from "../api";
import adaptPrediction from "../adaptPrediction";
import PredictionChart from "./PredictionChart";
const Prediction = () => {
    const { predictionId } = useParams();
    invariant(predictionId);
    const { patient, isLoading: isPatientLoading } = usePatient();
    const { data: prediction, isLoading: isPredictionLoading } = useGetPredictionQuery(predictionId);
    if (isPatientLoading || isPredictionLoading) {
        return _jsx(Spinner, {});
    }
    invariant(prediction);
    invariant(patient);
    return (_jsx(CurrentPatientProvider, Object.assign({ value: { patient: patient } }, { children: _jsx(PredictionPage, { prediction: adaptPrediction(prediction), charts: prediction.trends.map((trend) => (_jsx(PredictionChart, { prediction: prediction, trend: trend }, trend.metricType))) }) })));
};
export default Prediction;
